import {
  Box,
  Heading,
  HStack,
  Image,
  Text,
  VStack,
  Stack,
  useToast,
  Button,
  Input,
} from '@chakra-ui/react';
import { isEmpty } from 'lodash';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useRecoilState } from 'recoil';
import _isEmpty from 'lodash/isEmpty';
import Layout from '../../modules/layout/layout';
import cartoon from '../../static/assets/images/cartoon.svg';
import heartfull from '../../static/assets/images/HeartChecked.svg';
import heartempty from '../../static/assets/images/HeartUnchecked.svg';
import EmailIcon from '../../static/assets/images/emailIcon.svg';
import { AiOutlineHeart, AiFillHeart } from 'react-icons/ai';
import { Icon } from '@chakra-ui/react';
import '../../styles/portalys/portalys.css';
import { user } from '../../recoil/atoms/user';
import { theme } from '../../styles/theme/base';
import axios from '../../utils/api/axios';
import secrets from '../../secrets';
import { NotificationComponent } from '../../modules/shared/notificationComponent';
import { useMediaQuery } from '../../utils/useMediaQuery';
const moment = require('moment-timezone');
import AppStore from '../../static/assets/images/app-store.svg';
import GooglePlay from '../../static/assets/images/google-play.svg';
import ImageTextComponent from '../../modules/pages/Home/EventsOverview/ImageTextComponent';
import appMockup from '../../static/assets/images/app-mockup.png';
import { MarketPlaceComponent, MarketPlaceComponent2 } from '../appPromo/downloadApp';
import bgDesktop from '../../static/assets/images/bgMarketplace-desktop.png';
import bgMobile from '../../static/assets/images/bgMarketplace-mobile.png';
import bgMobileWA from '../../static/assets/images/mobile-bg-wa.png';
import bgDesktopWA from '../../static/assets/images/desktop-bg-wa.png';


export const formatDate = (dateString, timeZone) => {
  // Parse the input date string in the specified time zone
  const originalDate = moment.tz(dateString, timeZone);
  const day = originalDate.format('D');
  const month = originalDate.format('MMM');
  const weekday = originalDate.format('ddd');

  return `${weekday}, ${day} ${month}`;
};

// Function to format the time to 13h25 format
export const formatTime = (timeString) => {
  const [hours, minutes] = timeString.split(':');
  // Use Moment.js to format the time with AM/PM
  const formattedTime = moment()
    .hours(hours)
    .minutes(minutes)
    .format('hh:mm A');
  return formattedTime;
};

export default function NewsEvents({ init, events }) {
  const isMobile = useMediaQuery('(max-width: 768px)');
  const isTablet = useMediaQuery('(max-width: 1179px)');
  const [email, setEmail] = useState('');
  const [isFocus, setIsFocus] = useState(false);

  const [activeIndex, setActiveIndex] = useState(0);
  const navigate = useNavigate();
  //const [events, setEvents] = useState([]);
  const [_, setUser] = useRecoilState(user);
  const toast = useToast();

  const handleAppStoreClick = () => {
    window.open(secrets.iosLink, '_blank');
  };

  const handleGooglePlayClick = () => {
    window.open(secrets.androidLink, '_blank');
  };

  const handleJoinWAClick = () => {
    window.open('https://chat.whatsapp.com/JndYwKRMwzlDjOAonMik4A?fbclid=PAZXh0bgNhZW0CMTEAAaaQEVniW2aMsDa2KhzpoHc2PtR_3wEciuzPTT6h-1MPgiLYTw99Yq0qWrw_aem_N7YuU8Z8lpe2uUK6Ry7zCA', '_blank');
  };

  const handleLikeEvent = async (id) => {
    if (_.token) {
      await axios
        .post('/api/likeEvent/' + id, {
          headers: {
            'x-auth-token': _?.token,
          },
        })
        .then((res) => {
          init();
          const data = res.data;
          toast({
            position: 'top-right',
            duration: 4000,
            render: ({ onClose }) => (
              <NotificationComponent
                title={
                  data?.message === 'Event Liked'
                    ? 'Event has been added to your wishlist'
                    : 'Event has been removed from your wishlist'
                }
                status={data.status ? 'success' : 'error'}
                onClose={onClose}
              />
            ),
          });
        })
        .catch((err) => {
          console.log({ err });
        });
    } else {
      toast({
        position: 'top-right',
        duration: 4000,
        render: ({ onClose }) => (
          <NotificationComponent
            title={'Please Login'}
            status={'error'}
            onClose={onClose}
          />
        ),
      });
    }
  };
  const subscribe = async () => {
    console.log({ email });
    if (!email) {
      return toast({
        title: 'Please enter you email first!',
        status: 'warning',
        isClosable: true,
        duration: 4000,
        position: 'top-right',
      });
    }
    await axios
      .post('/api/subscribe', { email })
      .then((res) => {
        const data = res.data;
        toast({
          title: data.message,
          status: data.status ? 'success' : 'error',
          isClosable: true,
          duration: 4000,
          position: 'top-right',
        });
      })
      .catch((err) => {
        console.log({ err });
        toast({
          title: err.message,
          status: 'error',
          isClosable: true,
          duration: 4000,
          position: 'top-right',
        });
      });
  };

  const shortenToFirstTwoWords = (inputString) => {
    const words = inputString.split(' ');
    return words.slice(0, 2).join(' ');
  };

  return (
    <Box w="100%" display="flex" justifyContent="center" alignItems="center">
      <Box className="gordita400" w="100%">
        <Box
          display="flex"
          width="100%"
          paddingLeft={!isMobile ? "64px" : "0px"}
          justifyContent="center"
          alignItems="center"
          gap="80px"
          borderRadius="24px"
          border="1px solid rgba(255, 255, 255, 0.32)"
          background="#000"
          position="relative"
          backgroundImage={isMobile ? bgMobile : bgDesktop}
          backgroundRepeat="no-repeat"
          backgroundSize="100% 100%"
        >

          <Box
            display="flex"
            width="100%"
            maxWidth="488px"
            padding={isMobile ? "32px 24px" : "64px 0px"}
            flexDirection="column"
            alignItems="flex-start"
            gap="24px"
            flexShrink="0"
          >
            <Box
              display="flex"
              flexDirection="column"
              alignItems="flex-start"
              gap="12px"
              alignSelf="stretch"
            >
              <Text
                alignSelf="stretch"
                color="#FFF"
                textAlign="center"
                fontFamily="Gordita"
                fontSize="48px"
                fontStyle="normal"
                fontWeight="700"
                lineHeight="132%"
                letterSpacing="-0.96px"
              >
                 Real People. <br /> Real Tickets.
              </Text>

              <Text
                alignSelf="stretch"
                color="rgba(255, 255, 255, 0.80)"
                textAlign="center"
                fontFamily="Gordita"
                fontSize={isMobile ? "20px" : "22px"}
                fontStyle="normal"
                fontWeight="700"
                lineHeight="148%"
              >
                Buy tickets to upcoming events or resell tickets for ones you can't make!
              </Text>
            </Box>
          </Box>
        </Box>



        <Box
          w="100%"
          display="flex"
          justifyContent="center"
          alignItems="center"
          rowGap="1.25rem"
          columnGap="1.25rem"
          flexWrap="wrap"
          marginTop="30px"
        >
          {events?.map(
            (
              {
                eventImage: image,
                eventName: heading,
                startDate: sdate,
                startTime: time,
                endTime: etime,
                city,
                country,
                uuid,
                isLiked,
                organizedBy,
                slug,
                timezone,
                isResell,
              },
              index
            ) => {
              const formattedDate = formatDate(sdate, timezone);
              const formattedTime = formatTime(time);
              const formattedETime = formatTime(etime);

              return (
                <Box
                  cursor="pointer"
                  onClick={() => isResell ? navigate('/resell/event/' + slug) : navigate('/event/' + slug)}
                  key={index}
                  sx={theme.card.primary.shape}
                  pos={'relative'}
                >
                  <Box
                    width="2.75rem"
                    height="2.75rem"
                    flexShrink="0"
                    borderRadius="6.25rem"
                    border="1px solid rgba(255, 255, 255, 0.05)"
                    bg={'rgba(0, 0, 0, 0.50)'}
                    backdropFilter={'blur(150px)'}
                    display={'flex'}
                    justifyContent={'center'}
                    alignItems={'center'}
                    pos={'absolute'}
                    right={'1.12rem'}
                    top={'1.12rem'}
                    _hover={{ background: !isLiked && '#000' }}
                  >
                    <Icon
                      as={isLiked ? AiFillHeart : AiOutlineHeart}
                      color="white.100"
                      w="1.5rem"
                      h="1.5rem"
                      cursor="pointer"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleLikeEvent(uuid);
                      }}
                    />
                  </Box>
                  <Image
                    w={'100%'}
                    h="28.0625rem"
                    objectFit={'cover'}
                    flexShrink={0}
                    borderRadius="var(--radius-radius-big, 0.9375rem)"
                    src={image}
                  />

                  <VStack
                    margin="1.25rem 0.62rem"
                    display="block"
                    gap={'0.62rem'}
                  >
                    <Heading
                      color="#FBFAFB"
                      className="gordita700"
                      fontSize="1.4375rem"
                      style={{
                        maxWidth: '100%',
                        overflow: 'hidden',
                        whiteSpace: 'nowrap',
                        textOverflow: 'ellipsis',
                      }}
                    >
                      {heading}
                    </Heading>

                    <HStack
                      fontSize={{ base: 14, md: 16, '3xl': 16 }}
                      w="100%"
                      className="gordita400"
                    >
                      <Text className="gordita600">{formattedDate}</Text>
                      <Text> </Text>
                      <Text>{formattedTime + ' - ' + formattedETime}</Text>
                    </HStack>

                    <HStack
                      fontSize={{ base: 14, md: 16, '3xl': 16 }}
                      w="100%"
                      className="gordita400"
                    >
                      <Text
                        style={{
                          width: '50%',
                          overflow: 'hidden',
                          whiteSpace: 'nowrap',
                          textOverflow: 'ellipsis',
                        }}
                      >
                        {organizedBy?.name || 'Portalys Resell'}
                      </Text>
                      <Text
                        color="rgba(255, 255, 255, 0.60)"
                        fontSize="1rem"
                        style={{
                          width: '50%',
                          overflow: 'hidden',
                          whiteSpace: 'nowrap',
                          textOverflow: 'ellipsis',
                        }}
                      >
                        {city || ''} {city && country ? ', ' : ''}{' '}
                        {country || ''}
                      </Text>
                    </HStack>
                  </VStack>
                </Box>
              );
            }
          )}

          <MarketPlaceComponent
            maxW={
              !isTablet &&
              (events?.length % 3 === 0 ||
                (events?.length % 3 === 1 && events?.length !== 1))
                ? '48.75rem'
                : '23.75rem'
            }
            padding={
              !isTablet &&
              (events?.length % 3 === 0 ||
                (events?.length % 3 === 1 && events?.length !== 1))
                ? '2rem 5rem'
                : '2rem 1.25rem'
            }
            isTablet={isTablet}
            isMobile={isMobile}
          />
        </Box>


<Box
  display="flex"
  justifyContent="center"
  alignItems="center"
>
  {isMobile ? (
    <Box
      display="flex"
      padding="48px 20px"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      gap="32px"
      alignSelf="stretch"
      borderRadius="24px"
      border="1px solid rgba(255, 255, 255, 0.24)"
      background="#000"
      position="relative"
      backgroundImage={bgMobileWA}
      backgroundRepeat="no-repeat"
      backgroundSize="100% 100%"
      marginTop="32px"
    >
      <Text
        alignSelf="stretch"
        color="var(--Text-T---Primary, #FFF)"
        textAlign="center"
        fontFamily="Gordita"
        fontSize="28px"
        fontStyle="normal"
        fontWeight="700"
        lineHeight="140%" /* 39.2px */
        letterSpacing="-0.84px"
      >
        Join our WA group to sell your tickets faster!
      </Text>
      <Button
        fontWeight="700"
        textAlign="center"
        margin="0 20px"
        fontSize="1rem"
        borderRadius="40px"
        outline="none"
        sx={theme.buttons.primary.shape}
        bg={theme.buttons.primary.default}
        color={theme.buttons.primary.color}
        className="gordita700"
        css={{
          width: "100%",
        }}
        _hover={{
          bg: theme.buttons.primary.hover,
          boxShadow: theme.buttons.primary.hoverBoxShadow,
          cursor: "pointer",
        }}
        _active={{
          boxShadow: theme.buttons.primary.activeBoxShadow,
        }}
        _disabled={{
          bg: theme.buttons.primary.disabled,
          color: theme.buttons.primary.colorDisabled,
        }}
        onClick={handleJoinWAClick}
      >
        Join Now!
      </Button>
    </Box>
  ) : (
    <Box
      display="flex"
      maxWidth="978px"
      width="100%"
      justifyContent="center"
      alignItems="center"
      gap={isMobile ? "32px" : "80px"}
      borderRadius="24px"
      border="1px solid rgba(255, 255, 255, 0.32)"
      background="#000"
      position="relative"
      backgroundImage={isMobile ? bgMobileWA : bgDesktopWA}
      backgroundRepeat="no-repeat"
      backgroundSize="100% 100%"
      marginTop={isMobile ? "32px" : "84px"}
    >
      <Box
        display="flex"
        maxWidth="378px"
        width="100%"
        padding="56px 0px"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        gap="32px"
        flexShrink="0"
      >
        <Box
          display="flex"
          flexDirection="column"
          alignItems="flex-start"
          gap="12px"
          alignSelf="stretch"
        >
          <Text
            alignSelf="stretch"
            color="var(--Text-T---Primary, #FFF)"
            textAlign="center"
            fontFamily="Gordita"
            fontSize="28px"
            fontStyle="normal"
            fontWeight="700"
            lineHeight="140%" /* 39.2px */
            letterSpacing="-0.84px"
          >
            Join our WA group to sell your tickets faster!
          </Text>
          <Button
            fontWeight="700"
            textAlign="center"
            margin={isMobile ? "0 20px" : "20px 0"}
            fontSize="1rem"
            borderRadius="40px"
            outline="none"
            sx={theme.buttons.primary.shape}
            bg={theme.buttons.primary.default}
            color={theme.buttons.primary.color}
            className="gordita700"
            css={{
              width: "100%",
            }}
            _hover={{
              bg: theme.buttons.primary.hover,
              boxShadow: theme.buttons.primary.hoverBoxShadow,
              cursor: "pointer",
            }}
            _active={{
              boxShadow: theme.buttons.primary.activeBoxShadow,
            }}
            _disabled={{
              bg: theme.buttons.primary.disabled,
              color: theme.buttons.primary.colorDisabled,
            }}
            onClick={handleJoinWAClick}
          >
            Join Now!
          </Button>
        </Box>
      </Box>
    </Box>
  )}
</Box>
   </Box>

      </Box>
  );
}
